import { render, staticRenderFns } from "./DataConfirmation.vue?vue&type=template&id=2cc79a01&"
import script from "./DataConfirmation.vue?vue&type=script&lang=js&"
export * from "./DataConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2cc79a01', component.options)
    } else {
      api.reload('2cc79a01', component.options)
    }
    module.hot.accept("./DataConfirmation.vue?vue&type=template&id=2cc79a01&", function () {
      api.rerender('2cc79a01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/DataConfirmation.vue"
export default component.exports